module.exports = __webpack_public_path__ + "element_logo-05b3bc40.png";